// extracted by mini-css-extract-plugin
export default {"container":"Burn_container__aIyif","error":"Burn_error__n2ioh","invert":"Burn_invert__wyN3y","defualtLoader":"Burn_defualtLoader__EZpNf","loader":"Burn_loader__lYiLr"};